import { getWidth } from "../common";

// skipping 9
// https://dd-is.atlassian.net/browse/OMEMCDEV-2916
const column_headers = [1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14];
export default column_headers.map((current) => {
  const field = `relay_mechanical_${current}`;
  return {
    field,
    label: field,
    width: getWidth(column_headers.length),
    isSortable: false,
    isCSV: true,
  };
});
